import React from 'react';
import { Box, Typography } from '@mui/material';
import classes from './List.module.css';
import Grid from '@mui/material/Unstable_Grid2/Grid2';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';

// 타이틀에 화살표 아이콘이 포함되고 하위에 리스트형식으로 구성된 컴포넌트
/**
 * 
 * @param {*} props.description - array 
 * @returns 
 */
export const BoxCard = props => {

    return (
        <Box {...props}>
            <Box
                display='flex'
                alignItems='center'
            >
                <ArrowCircleRightIcon fontSize='medium' sx={{color: '#6a758d'}}/>
                <Typography 
                    variant="contentTitleSmall" 
                    component="p"
                    sx={{marginTop: '10px', marginBottom: '10px'}}
                >
                    {props.title}
                </Typography>
            </Box>
            
            {props.description &&
            <Box className={classes['box-card']}>

                { props.description.map((item, index) => (
                    <Typography 
                        key={index}
                        variant="description" 
                        component="p"
                        lineHeight="1.5"
                        padding="10px"
                    >
                        {item}
                    </Typography>
                ))}
            </Box>
            }
        </Box>
    )
}


// 체크박스가 포함된 박스 카드 형태
export const JobResponse = props => {
    return (
            <Box 
                display='flex'
                alignItems='center'
                elevation={1}
                sx={{
                    backgroundColor:'#ffff', 
                    borderRadius:"10px", 
                    minHeight:"100px", 
                    padding:'10px',
                    width: '100%'
                }}
                {...props}
            >
                <CheckCircleIcon sx={{color:'green', marginRight: '5px'}}/>
                <Typography 
                    variant="contentTitleSmall" 
                    component='p'
                    lineHeight='1.5'
                    textAlign='left'
                    marginBottom='0'
                >
                    {props.title}
                </Typography>
            </Box>
    )
}


// 이미지가 포함된 번호가있는 리스트
export const ImageNumberList = props => {
    return (
        <Box className={classes['numberlist-box']} {...props}>
            <Grid container alignItems='center' justifyContent='center'>
                <Grid xs={12} md={3}>
                    <img src={props.image} alt={props.alt}/>
                </Grid>
                <Grid container xs={12} md={9}>
                    {props.data.map((item, index) => (
                        <Grid 
                            xs={12} 
                            md={6} 
                            key={index}
                            display="flex" 
                            alignItems="center"
                            paddingRight="0.5rem"
                        >
                            
                            <Typography variant="body1" component="span" padding="0.5rem" textAlign='left'>
                                <span className={classes.number}>{index+1}</span>
                                {item}
                            </Typography>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Box>
    )
}

// ul 리스트 (title, subtitle 형태)
export const UlList = props => {
    return (
        <ul {...props}>
            {props.data.map((item, index) => (
                <li key={index} className={classes['ullist-main']}>
                    <div className={classes['ullist-title']}>
                        <Typography variant="description" component="p">{props.icon ? props.icon : '▶'} {item.title}</Typography>
                    </div>
                    {item.sub && 
                    <ul className={classes['ullist-sub']}>
                        {
                        item.sub.map((description, subindex) => (
                            <li key={subindex}>
                                <div className={classes['ullist-subtitle']}>
                                    
                                    <Typography variant="description2" component="p">{props.subicon ? props.subicon : '▷'} {description}</Typography>
                                </div>
                            </li>
                            )
                        )}
                    </ul>}
                </li>
            ))}
        </ul>
    )
}

export const DefaultList = props => {
    return (
        <ul className={classes.defaultList} {...props}>
            {props.data.map((item, index) => (
                <li key={index}><Typography variant="description2" component="p">{item}</Typography></li>
            ))}
        </ul>
    )
}



